import type { Replacements } from "@lib/utils/interpolateText";
import type { ReactNode } from "react";

export type MicrocopySetKey = "shared" | "page" | string;

export type MicrocopyGetOptions = {
    replacements?: Replacements;
    fromMultiple?: boolean;
    jsx?: boolean;
};

export interface MicrocopySet {
    [key: string]: {
        id: string;
        key: string;
        value: string;
    };
}

export interface MicrocopyContextState {
    shared: MicrocopySet;
    page: MicrocopySet;
    [key: string]: MicrocopySet;
}

export interface MicrocopyContextAPI {
    get: <T extends boolean = false>(
        microcopySetKey: MicrocopySetKey,
        microcopyKey: string,
        options?: MicrocopyGetOptions & { jsx?: T }
    ) => T extends true ? ReactNode | null : string | null;
    getMultiple: (
        microcopySetKey: MicrocopySetKey,
        microcopyKeys: readonly string[],
        options?: MicrocopyGetOptions
    ) => { [key: string]: string } | null;
}

export enum LogMicrocopyType {
    GET_SINGLE = "getSingle",
    GET_MULTIPLE = "getMultiple",
}

export enum LogMicrocopyError {
    MISSING_MICROCOPY_SET = "Missing Microcopy Set",
    MISSING_MICROCOPY = "Missing Microcopy",
}
